require('./components/back_to_planner/back_to_planner.ts');
require('./components/back_to_planner/constants/planner_constants.ts');
require('./components/back_to_planner/helpers/back_to_planner_helper.ts');
require('./components/busy_times/busy_times.ts');
require('./components/add_busy_time/add_busy_time.ts');
require('./components/corequisite_drop_list/corequisite_drop_list.ts');
require('./components/course_alerts/course_alerts.ts');
require('./components/course_alerts/commands/save_course_alerts_command.ts');
require('./components/course_alerts/models/course_alerts_model.ts');
require('./components/course_alerts/queries/course_alerts_query.ts');
require('./components/course_missing_requisites/course_missing_requisites.ts');
require('./components/crn_search/commands/crn_clear_search_command.ts');
require('./components/crn_search/commands/crn_search_command.ts');
require('./components/crn_search/components/crn_course_tile/crn_course_tile.ts');
require('./components/crn_search/crn_search.ts');
require('./components/crn_search/models/crn_search_model.ts');
require('./components/crn_search/queries/crn_search_query.ts');
require('./components/crn_search/search_results_list.ts');
require('./components/frame_scroll/frame_scroll.ts');
require('./components/inactive_section_banner/inactive_section_banner.ts');
require('./components/meeting_times/meeting_times.ts');
require('./components/meeting_times/servants/meeting_time_servant.ts');
require('./components/meeting_times_banner/meeting_times_banner.ts');
require('./components/modal/modal.ts');
require('./components/selected_section_actions_menu/selected_section_actions_menu.ts');
require('./components/selected_section_actions_menu/queries/selected_section_actions_menu_query.ts');
require('./components/selected_section_actions_modal/selected_section_actions_modal.ts');
require('./components/planned_course_search_navigation/planned_course_search_navigation.ts');
require('./components/registration_rtr/registration_rtr.ts');
require('./components/scheduler_header/scheduler_header.ts');
require('./components/section_action_button/section_action_button.ts');
require('./components/section_action_button/section_action_wait_list_prompt/section_action_wait_list_prompt.ts');
require('./components/section_action_button/strategies/section_action_strategy.ts');
require('./components/section_badges/section_badges.ts');
require('./components/section_selections/commands/update_selected_linked_section_status_command.ts');
require('./components/section_selections/commands/process_selected_registerable_section_command.ts');
require('./components/section_selections/commands/update_section_selection_command.ts');
require('./components/section_selections/commands/remove_section_selection_command.ts');
require('./components/section_selections/commands/update_selected_section_status_command.ts');
require('./components/section_selections/models/section_selections_model.ts');
require('./components/section_selections/queries/section_selections_query.ts');
require('./components/section_selections/servants/section_selections_servant.ts');
require('./components/section_conflict_prompt/section_conflict_prompt.ts');
require('./components/section_corequisite/builders/cross_course_corequisite_builder.ts');
require('./components/section_corequisite/commands/clear_cross_course_linked_sections_command.ts');
require('./components/section_corequisite/commands/get_cross_course_linked_sections_command.ts');
require('./components/section_corequisite/datasources/cross_course_corequisite_datasource.ts');
require('./components/section_corequisite/models/cross_course_linked_sections_model.ts');
require('./components/section_corequisite/section_corequisite.ts');
require('./components/section_corequisite/strategies/section_coreq_strategy.ts');
require('./components/section_details/commands/get_section_details_command.ts');
require('./components/section_details/models/section_detail_model.ts');
require('./components/section_details/queries/section_details_query.ts');
require('./components/section_details/section_details.ts');
require('./components/section_filters/commands/clear_section_filters_command.ts');
require('./components/section_filters/commands/get_section_filters_command.ts');
require('./components/section_filters/commands/save_section_filters_command.ts');
require('./components/section_filters/models/section_filters_model.ts');
require('./components/section_filters/models/selected_section_filters_model.ts');
require('./components/section_filters/queries/section_filters_query.ts');
require('./components/section_filters/section_filters.ts');
require('./components/section_time_length/section_time_length.ts');
require('./components/student_availability/commands/delete_student_availability_command.js');
require('./components/student_availability/commands/load_student_availability_command.js');
require('./components/student_availability/commands/save_student_availability_command.js');
require('./components/student_availability/student_availability.js');
require('./components/system_message/system_message.ts');
require('./components/term_pin/commands/get_term_pin_command.ts');
require('./components/term_pin/commands/save_term_pin_command.ts');
require('./components/term_pin/models/term_pin_model.ts');
require('./components/term_pin/queries/term_pin_query.ts');
require('./components/term_pin/servants/term_pin_servant.ts');
require('./components/term_pin/term_pin.ts');
require('./components/time_slice_tiles/commands/save_selected_time_slice_to_model.ts');
require('./components/time_slice_tiles/models/selected_time_slice_model.ts');
require('./components/time_slice_tiles/queries/time_slice_query.ts');
require('./components/time_slice_tiles/servants/time_slice_servant.ts');
require('./components/time_slice_tiles/time_slice_tiles.ts');
require('./components/timeline/queries/timeline_query.ts');
require('./components/timeline/servants/timeline_servant.ts');
require('./components/timeline/strategies/timeline_theme_strategy.ts');
require('./components/timeline/timeline.ts');
require('./components/withdraw_modal/withdraw_modal.ts');
require('./config/calendar_configuration.ts');
require('./config/models/scheduler_config_model.ts');
require('./config/state_configuration.ts');
require('./global/helpers/scheduler_notification_delegate.ts');
require('./hil/hil_connector_by_input/hil_connector_by_input.ts');
require('./interfaces/scheduler_interfaces.ts');
require('./modules.ts');
require('./prevent_transient_access/builders/transient_access_cred_builder.ts');
require('./prevent_transient_access/builders/transient_access_cred_workflow_builder.ts');
require('./prevent_transient_access/commands/clear_transient_access_cred_command.ts');
require('./prevent_transient_access/commands/save_transient_access_cred_command.ts');
require('./prevent_transient_access/commands/update_transient_access_cred_workflow_command.ts');
require('./prevent_transient_access/components/transient_access_cred_dialog/transient_access_cred_dialog.ts');
require('./prevent_transient_access/components/transient_access_cred_form/transient_access_cred_form.ts');
require('./prevent_transient_access/components/transient_access_cred_steps_component/transient_access_cred_steps_component.ts');
require('./prevent_transient_access/constants/transient_access_cred_constants.ts');
require('./prevent_transient_access/models/transient_access_cred_model.ts');
require('./prevent_transient_access/models/transient_access_cred_workflow_model.ts');
require('./prevent_transient_access/queries/prevent_transient_access_query.ts');
require('./registration_attributes/builders/section_registraion_attributes_builder.ts');
require('./registration_attributes/commands/load_all_registration_attributes_for_sections_command.ts');
require('./registration_attributes/commands/load_section_registration_attributes_command.ts');
require('./registration_attributes/commands/remove_section_registration_attributes_command.ts');
require('./registration_attributes/commands/store_registration_attribute_values_command.ts');
require('./registration_attributes/commands/submit_reg_attr_form_and_get_output_command.ts');
require('./registration_attributes/commands/wait_for_registration_attributes_to_render_command.ts');
require('./registration_attributes/datasources/section_registration_attributes_datasource.ts');
require('./registration_attributes/facades/registration_attributes_facade.ts');
require('./registration_attributes/models/section_registration_attributes_form_output_model.ts');
require('./registration_attributes/queries/section_registration_attributes_query.ts');
require('./registration_attributes/servants/registration_attributes_servant.ts');
require('./registration_errors/commands/registration_error_dismiss_command.ts');
require('./registration_errors/components/registration_error_details/registration_error_details.ts');
require('./registration_errors/components/registration_errors.ts');
require('./registration_errors/queries/registration_errors_query.ts');
require('./registration_errors/strategies/registration_activity_text_strategy.ts');
require('./registration_receipt/commands/clear_registration_reciept_command.ts');
require('./registration_receipt/commands/registration_reciept_command.ts');
require('./registration_receipt/components/registration_receipt/registration_receipt.ts');
require('./registration_receipt/models/registration_reciept_model.ts');
require('./registration_receipt/queries/registration_receipt_query.ts');
require('./request_state/commands/campus_preferences_request_state_command.ts');
require('./request_state/commands/multi_sections_drop_withdraw_request_state_command.ts');
require('./request_state/commands/multi_sections_waitlist_request_state_command.ts');
require('./request_state/commands/registration_request_state_command.ts');
require('./request_state/commands/swap_request_state_command.ts');
require('./request_state/commands/scheduled_section_request_state_command.ts');
require('./request_state/models/request_state_model.ts');
require('./request_state/queries/request_state_query.ts');
require('./scheduler_active_term/commands/fetch_scheduler_available_terms_command.ts');
require('./scheduler_active_term/components/scheduler_active_term/scheduler_active_term.ts');
require('./scheduler_active_term/datasource/scheduler_available_terms_datasource.ts');
require('./scheduler_active_term/queries/scheduler_active_term_query/scheduler_active_term_query.ts');
require('./search_and_add_courses/builders/scheduler_available_item.ts');
require('./search_and_add_courses/builders/scheduler_student_plan.ts');
require('./search_and_add_courses/commands/fetch_student_active_plan_details_command.ts');
require('./search_and_add_courses/commands/remove_planned_course_scheduler_command.ts');
require('./search_and_add_courses/commands/reset_coreq_sections_metasource_command.ts');
require('./search_and_add_courses/commands/get_course_search_authorization_command.ts');
require('./search_and_add_courses/components/choose_active_term_menu/choose_active_term_menu.ts');
require('./search_and_add_courses/components/scheduler_planned_course_menu/scheduler_planned_course_menu.ts');
require('./search_and_add_courses/components/search_and_add_courses/course_search_view_template.ts');
require('./search_and_add_courses/components/search_and_add_courses/search_and_add_courses.ts');
require('./search_and_add_courses/components/search_and_add_courses/search_results_list_template.ts');
require('./search_and_add_courses/constants/search_and_add_courses_constants.ts');
require('./search_and_add_courses/datasource/student_plans_datasource.ts');
require('./search_and_add_courses/facades/search_and_courses_feature_facade.ts');
require('./search_and_add_courses/interfaces/scheduler_available_term.ts');
require('./search_and_add_courses/interfaces/scheduler_student_plan.ts');
require('./search_and_add_courses/models/course_search_authorization_model.ts');
require('./search_and_add_courses/queries/scheduler_available_terms_query.ts');
require('./search_and_add_courses/queries/scheduler_student_plan_query.ts');
require('./search_and_add_courses/queries/course_search_authorization_query.ts');
require('./search_and_add_courses/servants/authorization_servant.ts');
require('./search_and_add_courses/state_configuration.ts');
require('./standalone_scheduler/commands/navigate_to_scheduler_command.ts');
require('./standalone_scheduler/commands/clear_standalone_scheduler_info_command.ts');
require('./standalone_scheduler/helpers/router_helper.ts');
require('./standalone_scheduler/models/standalone_navigation_model.ts');
require('./standalone_scheduler/queries/standalone_scheduler_details_query.ts');
require('./standalone_scheduler/state_configuration.ts');
require('./swap/commands/clear_swap_selections_command.ts');
require('./swap/commands/clear_swap_to_sections_command.ts');
require('./swap/commands/get_swap_command.ts');
require('./swap/commands/save_swap_command.ts');
require('./swap/commands/save_swap_from_section_command.ts');
require('./swap/commands/save_swap_to_section_command.ts');
require('./swap/commands/update_swap_from_section_type_command.ts');
require('./swap/commands/update_swap_section_status_command.ts');
require('./swap/components/calendar_scheduled_section_swap_button/calendar_scheduled_section_swap_button.ts');
require('./swap/components/section_swap_preview/section_swap_preview.ts');
require('./swap/components/swap_confirmation_dialog/swap_confirmation_dialog.ts');
require('./swap/components/swap_footer/swap_footer.ts');
require('./swap/components/swap_header/swap_header.ts');
require('./swap/components/swap_preview_banner/swap_preview_banner.ts');
require('./swap/components/swap_preview_section_tile/swap_preview_section_tile.ts');
require('./swap/components/unscheduled_section_swap_button/unscheduled_section_swap_button.ts');
require('./swap/facades/swap_facade.ts');
require('./swap/interfaces/swap_section_interface.ts');
require('./swap/models/course_section_swap_model.ts');
require('./swap/queries/section_swap_preview_query.ts');
require('./swap/servants/section_swap_callback_servant.ts');
require('./swap/servants/section_swap_servant.ts');
require('./swap/strategies/swap_strategy.ts');
require('./utilities/is_check_time_with_instructor_fn.ts');
require('./utilities/tabindex/tab_index_cleaner.ts');
require('./utilities/tabindex/tabindex_remover_directive.ts');
require('./utilities/position_registration_alert.ts');
require('./views/aside/scheduler_navigation/components/scheduler_navigation_items/scheduler_navigation_items.ts');
require('./views/aside/scheduler_navigation/components/scheduler_navigation_menu/scheduler_navigation_menu.ts');
require('./views/aside/scheduler_navigation/components/quick_schedule_error_dialog/quick_schedule_error_dialog.ts');
require('./views/aside/scheduler_navigation/models/quick_schedule_model.ts');
require('./views/aside/scheduler_navigation/models/appointment_schedule_model.ts');
require('./views/aside/scheduler_navigation/commands/toggle_quick_schedule_error_command.ts');
require('./views/aside/scheduler_navigation/commands/get_appointment_schedule_label_command.ts');
require('./views/aside/scheduler_navigation/queries/scheduler_navigation_menu_query.ts');
require('./views/aside/scheduler_navigation/queries/quick_schedule_query.ts');
require('./views/aside/scheduler_navigation/facades/quick_schedule_facade.ts');
require('./views/aside/term_info/term_info.ts');
require('./views/calendar/commands/clear_calendar_section_times_command.ts');
require('./views/calendar/commands/delete_student_unavailability_command.ts');
require('./views/calendar/commands/load_student_unavailability_command.ts');
require('./views/calendar/commands/save_student_unavailability_command.ts');
require('./views/calendar/commands/update_calendar_section_times_command.ts');
require('./views/calendar/components/calendar/calendar.ts');
require('./views/calendar/components/calendar_scheduled_section/calendar_scheduled_section.ts');
require('./views/calendar/components/calendar_scheduled_section_button/calendar_scheduled_section_button.ts');
require('./views/calendar/models/calendar_times_model.ts');
require('./views/calendar/queries/calendar_swap_times_query.ts');
require('./views/calendar/queries/calendar_times_query.ts');
require('./views/calendar/servants/calendar_functions.ts');
require('./views/calendar/servants/calendar_scheduled_section_servant.ts');
require('./views/components/calendar_preferences_sync/calendar_preferences_sync.ts');
require('./views/components/calendar_section_hover/calendar_section_hover.ts');
require('./views/components/course_delivery_mode_badge/course_delivery_mode_badge.ts');
require('./views/components/preferences/builders/campus_location_builder.ts');
require('./views/components/preferences/builders/commitment_range_builder.ts');
require('./views/components/preferences/commands/delete_term_location_preferences_command.ts');
require('./views/components/preferences/commands/load_term_commitment_preferences_command.ts');
require('./views/components/preferences/commands/load_term_location_preferences_command.ts');
require('./views/components/preferences/commands/save_term_commitment_preferences_command.ts');
require('./views/components/preferences/commands/save_term_location_preferences_command.ts');
require('./views/components/preferences/components/campus_location/campus_location.ts');
require('./views/components/preferences/components/campus_location/types/campus_location_enum.js');
require('./views/components/preferences/components/campus_location/types/preference_type_enum.js');
require('./views/components/preferences/components/commitment_range/commitment_range.js');
require('./views/components/preferences/components/commitment_range/types/commitment_ranges_enum.js');
require('./views/components/preferences/models/preferences_campus_model.ts');
require('./views/components/preferences/models/preferences_commitment_model.ts');
require('./views/components/preferences/preferences.ts');
require('./views/components/preferences_summary/preferences_summary.ts');
require('./views/components/seats_info_component/seats_info_component.ts');
require('./views/components/seats_info_text/seats_info_text.ts');
require('./views/components/section_type_badge/section_type_badge.ts');
require('./views/components/set_preferences_reminder/set_preferences_reminder.ts');
require('./views/course_details/commands/get_course_details_command.ts');
require('./views/course_details/commands/save_coreq_course_to_term_ap1_command.ts');
require('./views/course_details/commands/save_coreq_course_to_term_ap3_command.ts');
require('./views/course_details/commands/save_coreq_course_to_term_command.ts');
require('./views/course_details/components/co_requisite_link/co_requisite_link.ts');
require('./views/course_details/components/course_details_component/course_detail_component.ts');
require('./views/course_details/facades/course_details_facade.ts');
require('./views/course_details/models/course_details_model.ts');
require('./views/course_details/queries/course_details_cross_coreq_query.ts');
require('./views/course_details/queries/course_details_query.ts');
require('./views/course_scheduler/builders/registration_section_builder.ts');
require('./views/course_scheduler/builders/suggestions/campus_builder.es.js');
require('./views/course_scheduler/builders/suggestions/course_builder.es.js');
require('./views/course_scheduler/builders/suggestions/location_builder.es.js');
require('./views/course_scheduler/builders/suggestions/mapping_functions/mapping_functions.es.js');
require('./views/course_scheduler/builders/suggestions/program_builder.es.js');
require('./views/course_scheduler/builders/suggestions/required_section_builder.es.js');
require('./views/course_scheduler/builders/suggestions/section_builder.es.js');
require('./views/course_scheduler/builders/suggestions/section_status_builder.es.js');
require('./views/course_scheduler/builders/suggestions/section_status_collection_builder.es.js');
require('./views/course_scheduler/builders/suggestions/section_time_builder.es.js');
require('./views/course_scheduler/builders/suggestions/section_type_builder.es.js');
require('./views/course_scheduler/builders/suggestions/term_builder.es.js');
require('./views/course_scheduler/builders/waitlist_status_builder.ts');
require('./views/course_scheduler/commands/clear_all_registration_sections_command.ts');
require('./views/course_scheduler/commands/drop_course_sections_command.ts');
require('./views/course_scheduler/commands/get_course_scheduler_command.ts');
require('./views/course_scheduler/commands/get_pusher_seats_available_command.ts');
require('./views/course_scheduler/commands/get_scheduler_config_command.ts');
require('./views/course_scheduler/commands/mark_selected_flag_for_scheduled_sections_command.ts');
require('./views/course_scheduler/commands/register_scheduled_sections_command.ts');
require('./views/course_scheduler/commands/remove_from_register_sections_command.ts');
require('./views/course_scheduler/commands/select_all_registration_sections_command.ts');
require('./views/course_scheduler/commands/unschedule_course_sections_command.ts');
require('./views/course_scheduler/commands/unschedule_section_command.ts');
require('./views/course_scheduler/commands/update_seat_availability_command.ts');
require('./views/course_scheduler/components/calendar_placeholder_alert/calendar_placeholder_alert.ts');
require('./views/course_scheduler/components/calendar_placeholder_alert/openModalFlag.ts');
require('./views/course_scheduler/components/linked_section_message/linked_section_message.ts');
require('./views/course_scheduler/components/multi_section_message/multi_section_message.ts');
require('./views/course_scheduler/components/multi_section_sections_required_tile/multi_section_sections_required_tile.ts');
require('./views/course_scheduler/components/register_sections_button/register_sections_button.ts');
require('./views/course_scheduler/components/section_tile_checkbox/section_tile_checkbox.ts');
require('./views/course_scheduler/components/scheduled_section_coreq_prereq_message/scheduled_section_coreq_prereq_message.ts');
require('./views/course_scheduler/components/scheduled_section_menu/scheduled_section_menu.ts');
require('./views/course_scheduler/components/scheduled_section_notification/scheduled_section_notification.ts');
require('./views/course_scheduler/components/scheduled_section_status_label/scheduled_section_status_label.ts');
require('./views/course_scheduler/components/scheduled_section_tile/scheduled_section_tile_component.ts');
require('./views/course_scheduler/components/scheduled_section_waitlist_message/scheduled_section_waitlist_message.ts');
require('./views/course_scheduler/components/scheduled_sections/scheduled_sections_component.ts');
require('./views/course_scheduler/components/scheduled_sections_header_dialog/scheduled_sections_header_dialog.ts');
require('./views/course_scheduler/components/section_group/section_group_component.ts');
require('./views/course_scheduler/components/section_tile_error/section_tile_error.ts');
require('./views/course_scheduler/components/section_tile_error_section_required/section_tile_error_section_required.ts');
require('./views/course_scheduler/constants/course_scheduler_constants.ts');
require('./views/course_scheduler/datasources/register_sections_datasource.ts');
require('./views/course_scheduler/datasources/waitlist_status_datasource.ts');
require('./views/course_scheduler/facades/selected_section_actions_facade.ts');
require('./views/course_scheduler/facades/refresh_seat_availability_facade.ts');
require('./views/course_scheduler/filters/register_sections_filters.ts');
require('./views/course_scheduler/filters/register_waitlist_filters.ts');
require('./views/course_scheduler/filters/scheduled_section_filters.ts');
require('./views/course_scheduler/index.ts');
require('./views/course_scheduler/modals/suggestions/builders/suggestions_builder.js');
require('./views/course_scheduler/modals/suggestions/commands/load_suggestions_command.js');
require('./views/course_scheduler/modals/suggestions/commands/save_suggestions_command.ts');
require('./views/course_scheduler/modals/suggestions/components/campus_list/campus_list.js');
require('./views/course_scheduler/modals/suggestions/services/suggestions_service.js');
require('./views/course_scheduler/modals/suggestions/suggestions.js');
require('./views/course_scheduler/models/registration_failure_model.ts');
require('./views/course_scheduler/models/registration_waitlist_position_model.ts');
require('./views/course_scheduler/models/scheduler_model.ts');
require('./views/course_scheduler/queries/all_sections_query.ts');
require('./views/course_scheduler/queries/register_sections_query.ts');
require('./views/course_scheduler/queries/scheduled_sections_query.ts');
require('./views/course_scheduler/queries/scheduler_custom_text_query.ts');
require('./views/course_scheduler/servants/cross_course_linked_section_servant.ts');
require('./views/course_scheduler/servants/multi_section_servant.ts');
require('./views/course_scheduler/servants/registration_alerts_servant.ts');
require('./views/course_scheduler/servants/registration_callback_servant.ts');
require('./views/course_scheduler/servants/registration_receipt_servant.ts');
require('./views/course_scheduler/servants/requisite_course_servant.ts');
require('./views/course_scheduler/servants/scheduled_section_servant.ts');
require('./views/course_scheduler/servants/registered_section_servant.ts');
require('./views/course_scheduler/servants/scheduled_section_status_servant.ts');
require('./views/course_scheduler/servants/scheduled_section_tile_servant.ts');
require('./views/course_scheduler/servants/section_registration_servant.ts');
require('./views/course_scheduler/servants/section_status_servant.ts');
require('./views/course_scheduler/servants/waitlist_callback_servant.ts');
require('./views/course_scheduler/servants/scheduler_notification_servant.ts');
require('./views/course_scheduler/services/term_schedule_flags.ts');
require('./views/course_scheduler/strategies/registration_waitlist_outcome_status_strategy.ts');
require('./views/course_scheduler/strategies/section_status_label_strategy.ts');
require('./views/course_scheduler/strategies/section_tile_error_strategy.ts');
require('./views/course_scheduler/types/registration_alert_messages.ts');
require('./views/course_scheduler/types/requisite_enum.ts');
require('./views/course_scheduler/types/scheduled_section_status_enum.ts');
require('./views/course_scheduler/types/section_tile_error_enum.ts');
require('./views/course_scheduler/types/section_tile_menu_enum.ts');
require('./views/registration/commands/get_registration_check_command.ts');
require('./views/registration/commands/update_registration_friendly_reminder_flags_command.ts');
require('./views/registration/commands/toggle_registration_friendly_reminder_prompt_command.ts');
require('./views/registration/commands/update_registration_request_pending_command.ts');
require('./views/registration/commands/update_registration_flag_command.ts');
require('./views/registration/commands/toggle_section_pins_dialog_command.ts');
require('./views/registration/commands/show_register_button_after_precheck_pass_command.ts');
require('./views/registration/components/empty_course_list_message/empty_course_list_message.ts');
require('./views/registration/components/registration_actions/registration_actions_component.ts');
require('./views/registration/components/registration_controls/registration_controls.ts');
require('./views/registration/components/registration_friendly_reminder_dialog/registration_friendly_reminder_dialog.ts');
require('./views/registration/components/registration_header/registration_header.ts');
require('./views/registration/components/registration_pins/pin_section_checkbox_input/pin_section_checkbox_input.ts');
require('./views/registration/components/registration_pins/pins_scheduled_sections/pins_scheduled_sections.ts');
require('./views/registration/components/registration_pins/multi_section_pin_checkbox_input/multi_section_pin_checkbox_input.ts');
require('./views/registration/components/registration_pins/queries/registration_pins_query.ts');
require('./views/registration/components/registration_pins/registration_pins_component.ts');
require('./views/registration/components/registration_pre_check/commands/hide_registration_pre_check_alert_command');
require('./views/registration/components/registration_pre_check/commands/set_pre_reg_check_message_alert_command');
require('./views/registration/components/registration_pre_check/commands/show_registration_pre_check_alert_command');
require('./views/registration/components/registration_pre_check/commands/toggle_pending_registration_pre_check_alert_command');
require('./views/registration/components/registration_pre_check/commands/toggle_refresh_registration_pre_check_alert_command');
require('./views/registration/components/registration_pre_check/models/registration_pre_check_alert_model');
require('./views/registration/components/registration_pre_check/queries/show_registration_pre_check_alert_query');
require('./views/registration/components/registration_pre_check/registration_pre_check.ts');
require('./views/registration/components/registration_term_pin/registration_term_pin_component.ts');
require('./views/registration/facades/drop_course_facade.ts');
require('./views/registration/facades/schedule_section_facade.ts');
require('./views/registration/facades/unschedule_section_facade.ts');
require('./views/registration/facades/registration_facade.ts');
require('./views/registration/facades/registration_section_facade.ts');
require('./views/registration/facades/registration_section_pins_facade.ts');
require('./views/registration/facades/registration_pins_permission_facade.ts');
require('./views/registration/facades/pay_tuition_facade.ts');
require('./views/registration/queries/registration_no_selected_sections_query.ts');
require('./views/registration/queries/registration_one_click_query.ts');
require('./views/registration/queries/registration_selected_sections_query.ts');
require('./views/registration/queries/registration_pins_permission_query.ts');
require('./views/registration/queries/pay_tuition_query.ts');
require('./views/registration/interfaces/registration_interfaces.ts');
require('./views/registration/models/registration_pins_model.ts');
require('./views/registration/models/registration_no_selected_sections_model.ts');
require('./views/registration/models/registration_one_click_model.ts');
require('./views/registration/models/registration_selected_sections_model.ts');
require('./views/registration/models/registration_pins_permission_model.ts');
require('./views/registration/registration_container.ts');
require('./views/registration_transactions/builders/registration_activity_builder.ts');
require('./views/registration_transactions/commands/registration_activity_command.ts');
require('./views/registration_transactions/components/registration_transactions.ts');
require('./views/registration_transactions/datasources/registration_activity_datasource.ts');
require('./views/registration_transactions/queries/registration_transactions_query.ts');
require('./views/registration_transactions/strategies/request_type_strategy.ts');
require('./views/registration_transactions/types/request_types.ts');
require('./views/sections/builders/campus_builder.ts');
require('./views/sections/builders/location_builder.ts');
require('./views/sections/builders/section_availability_builder.ts');
require('./views/sections/builders/section_builder.ts');
require('./views/sections/builders/section_labels_builder.ts');
require('./views/sections/builders/section_time_builder.ts');
require('./views/sections/datasources/campuses_datasource.ts');
require('./views/sections/datasources/locations_datasource.ts');
require('./views/sections/datasources/section_availability_datasource.ts');
require('./views/sections/datasources/section_labels_datasource.ts');
require('./views/sections/datasources/section_times_datasource.ts');
require('./views/sections/datasources/sections_datasource.ts');
require('./views/sections/facades/load_cross_course_linked_sections_facade.ts');
require('./views/sections/models/linked_sections_model.ts');
require('./views/sections/servants/linked_sections_servant.ts');
require('./views/sections/servants/section_info_servant.ts');
require('./views/services/preferences_busy_times.ts');
require('./views/services/preferences_campuses.ts');
require('./views/services/preferences_commitment.ts');
require('./views/term_courses/builders/term_course_builder.ts');
require('./views/term_courses/builders/term_course_section_type_builder.ts');
require('./views/term_courses/builders/term_planned_course_builder.ts');
require('./views/term_courses/builders/term_session_builder.ts');
require('./views/term_courses/commands/get_program_and_term_info_command.ts');
require('./views/term_courses/commands/get_term_courses_and_scheduled_sections_command.ts');
require('./views/term_courses/commands/get_term_courses_command.ts');
require('./views/term_courses/commands/get_term_sections_command.ts');
require('./views/term_courses/components/course_icons/course_icons.ts');
require('./views/term_courses/components/course_tile/course_tile.ts');
require('./views/term_courses/components/multi_section_course_tile/multi_section_course_tile_component.ts');
require('./views/term_courses/components/term_courses_list/term_courses_list_component.ts');
require('./views/term_courses/datasources/term_courses_datasource.ts');
require('./views/term_courses/datasources/term_planned_courses_datasource.ts');
require('./views/term_courses/datasources/term_section_types_datasource.ts');
require('./views/term_courses/datasources/term_sessions_datasource.ts');
require('./views/term_courses/facades/view_sections_facade.ts');
require('./views/term_courses/filters/course_filters.ts');
require('./views/term_courses/filters/section_type_filters.ts');
require('./views/term_courses/models/preferences_selection_model.ts');
require('./views/term_courses/models/term_program_info_model.ts');
require('./views/term_courses/queries/term_courses_query.ts');
require('./views/term_courses/servants/term_course_servant.ts');
require('./views/unscheduled_sections/commands/get_unscheduled_sections_and_availability_command.ts');
require('./views/unscheduled_sections/commands/load_campus_list_command.ts');
require('./views/unscheduled_sections/commands/get_unscheduled_sections_availability_command.ts');
require('./views/unscheduled_sections/commands/remove_selected_unscheduled_section_command.ts');
require('./views/unscheduled_sections/commands/save_selected_unscheduled_section_command.ts');
require('./views/unscheduled_sections/commands/schedule_section_command.ts');
require('./views/unscheduled_sections/commands/update_section_selected_flag_command.ts');
require('./views/unscheduled_sections/commands/view_more_times_command.ts');
require('./views/unscheduled_sections/commands/waitlist_section_command.ts');
require('./views/unscheduled_sections/components/unscheduled_section_tile/unscheduled_section_tile.ts');
require('./views/unscheduled_sections/components/unscheduled_sections/unscheduled_sections.ts');
require('./views/unscheduled_sections/components/unscheduled_sections_by_campus/unscheduled_sections_by_campus.ts');
require('./views/unscheduled_sections/filters/unscheduled_section_filters.ts');
require('./views/unscheduled_sections/models/selected_unscheduled_section_model.ts');
require('./views/unscheduled_sections/models/unscheduled_sections_visibility_model.ts');
require('./views/unscheduled_sections/queries/unscheduled_sections_query.ts');
require('./views/unscheduled_sections/servants/unscheduled_section_servant.ts');



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/core.ts